import { gql } from '@apollo/client';
import { useSuspenseQuery } from '@apollo/client/react';
import { useLocation } from 'react-router';

const VISIT_REQUEST_FOR_VISIT_BOOKING_FLOW_QUERY = gql`
    query VisitRequestForVisitBookingFlow($id: UUID!) {
        visitRequest(id: $id) {
            id
            notes
            state
            timezone
            fulfillmentWindow {
                startDate
                endDate
            }
            appointments {
                id
                clinician {
                    id
                    firstName
                    lastName
                }
                services {
                    id
                    name
                }
            }
        }
    }
`;

export type VisitRequestForVisitBookingFlow = {
    id: string;
    notes: string | null;
    state: string;
    timezone: string | null;
    fulfillmentWindow: {
        startDate: Date | null;
        endDate: Date | null;
    } | null;
    appointments: {
        id: string;
        clinician: {
            id: string;
            firstName: string;
            lastName: string;
        } | null;
        services: {
            id: string;
            name: string;
        }[];
    }[];
};

type VisitRequestForVisitBookingFlowQueryType = {
    visitRequest: VisitRequestForVisitBookingFlow | null;
};

export const useVisitRequestForVisitBookingFlow = () => {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const visitRequestId = params.get('visitRequestId');
    const { data } = useSuspenseQuery<VisitRequestForVisitBookingFlowQueryType>(
        VISIT_REQUEST_FOR_VISIT_BOOKING_FLOW_QUERY,
        {
            skip: !visitRequestId,
            variables: { id: visitRequestId },
        },
    );
    return data?.visitRequest ?? null;
};
